module.exports = __webpack_public_path__ + "img/axis-icon.133429b4.png";